import React, { Fragment, useCallback, useEffect, useRef, useState } from 'react';
import * as _ from 'lodash';
import Dialog from 'material-ui/Dialog';
import { Tabs, Tab } from 'material-ui/Tabs';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { FlatButton, MenuItem, RaisedButton, SelectField, TextField } from 'material-ui';

import api from 'services';
import { addNotification } from 'actions/notifications/notifications';

function AddTagsModal({
    manageTagsModalOpen, handleToggleManageTags, addNotification, getCategories, initialTagsCategories, 
}) {
    const [category, setCategory] = useState('');
    const [selectedCategory, setSelectedCategory] = useState('');
    const [description, setDescription] = useState('');
    const [tag, setTag] = useState('');
    const [isSending, setIsSending] = useState(false);
    const isMounted = useRef(true);
    
    useEffect(() => () => {
        isMounted.current = false;
    }, []);

    const onChangeCategory = (value) => {
        setCategory(value);
    };

    const onChangeDesciption = (value) => {
        setDescription(value);
    };

    const onChangeTag = (value) => {
        setTag(value);
    };

    const onSelectCategory = (value) => {
        setSelectedCategory(value);
    };

    const addCategory = useCallback(async (_category, _description) => {
        if (isSending) {
            return false;
        }

        setIsSending(true);

        const response = await api.addTagsCategories(_category, _description);
        
        if (response.errors) {
            addNotification({
                title: 'Error',
                message: response.errors[0].message || response.errors[0].messages[0],
                level: 'error',
                _id: new Date().getMilliseconds(),
                autoDismiss: 3,
            });
        } else {
            addNotification({
                title: 'Successful creation',
                message: 'Category created!',
                level: 'success',
                _id: new Date().getMilliseconds(),
                autoDismiss: 3,
            });
            getCategories();
            setCategory('');
            setDescription('');
        }
        
        setIsSending(false);

        if (isMounted.current) {
            setIsSending(false);
        }
    }, [isSending]);

    const addTag = useCallback(async (_tag, _selectedCategory) => {
        if (isSending) {
            return false;
        }

        setIsSending(true);

        if (!_tag || !_selectedCategory) {
            addNotification({
                title: 'Error',
                message: 'Tag name and category must be specified!',
                level: 'error',
                _id: new Date().getMilliseconds(),
                autoDismiss: 3,
            });
            setIsSending(false);
            return;
        }

        const response = await api.addTag(_tag, _selectedCategory.value);

        if (response.errors && response.errors.length) {
            console.log(response);
        } else {
            addNotification({
                title: 'Successful creation',
                message: 'Tag created!',
                level: 'success',
                _id: new Date().getMilliseconds(),
                autoDismiss: 3,
            });
            setSelectedCategory('');
            setTag('');
        }

        if (isMounted.current) {
            setIsSending(false);
        }

        setIsSending(false);
    }, [isSending]);

    const actions = [
        <FlatButton
            label="Cancel"
            primary
            onClick={() => {
                handleToggleManageTags();
            }}
        />,
    ];

    return (
        <Fragment>
            <Dialog
                open={manageTagsModalOpen}
                actions={actions}
                onRequestClose={handleToggleManageTags}
            >
                <Tabs>
                    <Tab label="Add Category" >
                        <div className='row'>
                            <div className='col-xs-4'>
                                <TextField 
                                    floatingLabelText='Add Category'
                                    value={category || ''}
                                    onChange={e => onChangeCategory(e.target.value)}
                                    fullWidth
                                />
                            </div>
                            <div className='col-xs-4'>
                                <TextField 
                                    floatingLabelText='Category Description'
                                    value={description || ''}
                                    onChange={e => onChangeDesciption(e.target.value)}
                                    multiLine
                                    fullWidth
                                />
                            </div>
                            <div className='col-xs-4' style={{ margin: 'auto', textAlign: 'center' }}>
                                <RaisedButton 
                                    onClick={() => addCategory(category, description)}
                                    label='Add'
                                    primary
                                    disabled={isSending}
                                />
                            </div>
                        </div>
                    </Tab>
                    <Tab label="Add Tag" >
                        <div className='row'>
                            <div className='col-xs-4'>
                                <TextField 
                                    floatingLabelText='Add Tag'
                                    value={tag || ''}
                                    onChange={e => onChangeTag(e.target.value)}
                                    errorText={!tag && 'Tag name required'}
                                    fullWidth
                                />
                            </div>
                            <div className='col-xs-4'>
                                <SelectField 
                                    floatingLabelText="Select Category"
                                    value={selectedCategory}
                                    onChange={(_e, _i, value) => onSelectCategory(value)}
                                    maxHeight={300}
                                    errorText={tag && !selectedCategory && 'Select tag category'}
                                >
                                    {
                                        initialTagsCategories.map((cat, index) => (
                                            <MenuItem 
                                                key={`tagCategory_${index}`}
                                                value={cat}
                                                primaryText={_.capitalize(cat.value)}
                                            />
                                        ))
                                    }
                                </SelectField>
                            </div>
                            <div className='col-xs-4' style={{ margin: 'auto', textAlign: 'center' }}>
                                <RaisedButton 
                                    onClick={() => addTag(tag, selectedCategory)}
                                    label='Add'
                                    primary
                                    disabled={!tag || isSending}
                                />
                            </div>
                        </div>
                    </Tab>
                </Tabs>
            </Dialog>
        </Fragment>
    );
}

export default connect(
    null,
    dispatch => bindActionCreators(
        {
            addNotification,
        },
        dispatch,
    ),
)(AddTagsModal);



// WEBPACK FOOTER //
// ./app/components/Cargoes/RealNames/AddTagsModal.jsx